<template>
  <Modal
    :title="computedTitle"
    :modal="modalAplicativo"
    max-width="960px"
    cardTextClass="pa-0"
    @close="$emit('close')"
    @save="save"
  >
    <div slot="header-right">
      <v-btn fab small text @click="$emit('close')" class="mr-3">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-btn fab small color="primary" @click="save">
        <v-icon>mdi-check</v-icon>
      </v-btn>
    </div>
    <v-row slot="inner-body" no-gutters>
      <v-col cols="12" class="pa-0">
        <Tabs
          background-color="grey lighten-3"
          :tabsHeader="aplicativoTabs"
          :tab="tab"
          headerKey="descricao"
          @tabChanged="tab = $event"
        >
          <v-form
            slot="Informações"
            @submit.prevent="save"
            v-model="valid"
            ref="aplicativoForm"
            lazy-validation
          >
            <v-col cols="12" class="px-4">
              <Input
                label="Descrição"
                filled  
                @input="aplicativo.descricao = $event"
                :value="aplicativo.descricao"
                :rules="[rules.required]"
                :autofocus="modalAplicativo"
              />
            </v-col>
          </v-form>

          <v-col slot="Recursos" cols="12">
            <Textarea
              @input="recursosJSON = $event"
              :value="recursosJSON"
              filled
              auto-grow
              hide-details
              spellcheck="false"
              placeholder="JSON Recursos"
            />
          </v-col>

          <v-col slot="Treeview" cols="12">
            <v-sheet class="pa-4 primary lighten-2">
              <v-row class="align-center">
                <v-col cols="12" sm="9">
                  <v-text-field
                    v-model="search"
                    label="Pesquisar"
                    dark
                    flat
                    solo-inverted
                    hide-details
                    clearable
                    clear-icon="mdi-close-circle-outline"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="2">
                  <v-btn
                    text
                    dark
                    @click="expandOrCollapseAll"
                  >
                    <v-icon left>{{ expandOrCollapseIcon }}</v-icon>
                    {{ expandOrCollapseText }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-sheet>
            <v-treeview
              :items="recursosTreeView"
              item-key="recurso"
              item-text="descricao"
              item-children="recursos"
              open-on-click
              :search="search"
              :open-all="expandAll"
              :key="treeviewKey"
            ></v-treeview>
          </v-col>
        </Tabs>
      </v-col>
    </v-row>
  </Modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { tryParseJSON } from '../../helpers';
import Modal from '../shared/Modal';
import Input from '../shared/Input';
import Textarea from '../shared/Textarea';
import Tabs from '../shared/Tabs';
import Aplicativo from '@/domain/Aplicativo';

export default {
  name: 'ModalAplicativo',
  props: {
    modalAplicativo: {
      type: Boolean,
      default: false
    },
    editAplicativo: {
      default: null
    }
  },
  components: {
    Modal,
    Input,
    Textarea,
    Tabs
  },
  data: () => ({
    valid: true,
    tab: '',
    search: '',
    aplicativo: new Aplicativo(),
    recursosTreeView: [],
    recursosJSON: '',
    expandAll: false,
    treeviewKey: 0,
    hasErrors: false
  }),
  watch: {
    modalAplicativo(value) {
      if (!value) this.resetModalData();
    },
    editAplicativo(value) {
      if (value) {
        this.aplicativo = value;
        this.recursosJSON = JSON.stringify(value.recursos);
        this.recursosTreeView = value.recursos ? value.recursos : [];
      }
    },
    tab(value) {
      if (value === 'tab-Treeview') {
        const validJSON = tryParseJSON(this.recursosJSON);

        if (validJSON) {
          this.recursosTreeView = validJSON;
          this.hasErrors = false;
        } else {
          this.hasErrors = true;
        }
      }
    }
  },
  computed: {
    ...mapGetters(['loading', 'rules']),
    expandOrCollapseIcon() {
      return this.expandAll ? 'mdi-collapse-all' : 'mdi-expand-all';
    },
    expandOrCollapseText() {
      return this.expandAll ? 'Recolher Tudo' : 'Expandir Tudo';
    },
    aplicativoTabs() {
      return this.hasErrors ?
      [
        { descricao: 'Informações' },
        { descricao: 'Recursos', icon: 'mdi-alert-circle', iconColor: 'error' },
        { descricao: 'Treeview' },
      ] :
      [
        { descricao: 'Informações' },
        { descricao: 'Recursos' },
        { descricao: 'Treeview' },
      ]
    },
    computedTitle() {
      return this.editAplicativo ? 'Edita Aplicativo' : 'Novo Aplicativo';
    }
  },
  methods: {
    ...mapActions(['addAplicativo', 'updateAplicativo']),
    resetModalData() {
      this.aplicativo = new Aplicativo();
      this.valid = true;
      this.tab = '';
      this.search = '';
      this.recursosTreeView = [];
      this.recursosJSON = '';
      this.expandAll = false;
      this.treeviewKey = 0;
      this.hasErrors = false;
    },
    expandOrCollapseAll() {
      this.expandAll = !this.expandAll;
      this.treeviewKey++;
    },
    save() {
      if (this.$refs.aplicativoForm.validate()) {
        if (this.editAplicativo) {
          this.aplicativo.recursos = JSON.parse(this.recursosJSON);
          this.updateAplicativo({ ...this.aplicativo });
          this.$emit('close');
        } else {
          this.addAplicativo({ ...this.aplicativo });
          this.$emit('close');
        }
      }
    }
  }
}
</script>

<style>

</style>